import React from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { InvalidCriteriaMessage } from "../shared/InvalidCriteriaMessage";
import { Input } from "../shared/Input";
import { wrapIterator } from "../../../shared/helper/IterableIteratorWrapper";
import { EnemyCombatPresetSelector } from "../combat/EnemyCombatPresetSelector";
import { gameStore } from "../../stores/GameStore";
import { sharedStore } from "../../stores/SharedStore";
import { editorStore } from "../../stores/EditorStore";
const CharacterData = styled.div.withConfig({
  displayName: "EditorSingleCharacterPropertiesEditor__CharacterData",
  componentId: "sc-1hizwgk-0"
})(["align-self:flex-start;flex-grow:1;"]);
const CharacterField = styled.div.withConfig({
  displayName: "EditorSingleCharacterPropertiesEditor__CharacterField",
  componentId: "sc-1hizwgk-1"
})(["display:flex;flex-direction:column;margin-bottom:16px;"]);
const InputText = styled(Input).withConfig({
  displayName: "EditorSingleCharacterPropertiesEditor__InputText",
  componentId: "sc-1hizwgk-2"
})(["width:250px;"]);
const InputNumber = styled(Input).withConfig({
  displayName: "EditorSingleCharacterPropertiesEditor__InputNumber",
  componentId: "sc-1hizwgk-3"
})(["width:70px;"]);
const InfoMessage = styled(InvalidCriteriaMessage).withConfig({
  displayName: "EditorSingleCharacterPropertiesEditor__InfoMessage",
  componentId: "sc-1hizwgk-4"
})(["color:white;"]);
export const EditorSingleCharacterPropertiesEditor = observer(({
  store
}) => {
  const {
    t
  } = useTranslation();
  const {
    selectedCharacterConfiguration
  } = store;

  function onTextFieldUpdate(e, handler) {
    handler(e.target.value);
  }

  const {
    textReferenceId,
    id
  } = selectedCharacterConfiguration;
  const textReferenceIdIsDuplicate = (textReferenceId === null || textReferenceId === void 0 ? void 0 : textReferenceId.length) > 0 && wrapIterator(sharedStore.characterConfigurations.values()).some(c => c.id !== id && c.textReferenceId === textReferenceId);
  const {
    languageKey
  } = gameStore;
  const nameWithoutFallback = selectedCharacterConfiguration.localizedName.get(languageKey, false);
  const nameIsDuplicateForCurrentLanguage = nameWithoutFallback && wrapIterator(sharedStore.characterConfigurations.values()).some(c => c.id !== id && c.localizedName.get(languageKey, false) === nameWithoutFallback);
  return /*#__PURE__*/React.createElement(CharacterData, null, /*#__PURE__*/React.createElement(CharacterField, null, t("editor.translated_name"), /*#__PURE__*/React.createElement(InputText, {
    type: "text",
    value: selectedCharacterConfiguration.localizedName.get(languageKey, false),
    placeholder: selectedCharacterConfiguration.localizedName.get(languageKey, true),
    onChange: e => onTextFieldUpdate(e, value => selectedCharacterConfiguration.localizedName.set(languageKey, value))
  }), nameIsDuplicateForCurrentLanguage && /*#__PURE__*/React.createElement(InfoMessage, null, t("editor.character_config_name_duplicate"))), editorStore.isMainGameEditor && /*#__PURE__*/React.createElement(CharacterField, null, t("editor.text_reference_id"), /*#__PURE__*/React.createElement(InputText, {
    type: "text",
    value: selectedCharacterConfiguration.textReferenceId,
    onChange: e => onTextFieldUpdate(e, value => selectedCharacterConfiguration.setTextReferenceId(value)),
    className: textReferenceIdIsDuplicate && "invalid"
  }), /*#__PURE__*/React.createElement(InvalidCriteriaMessage, null, textReferenceIdIsDuplicate && t("editor.warning_duplicate_text_reference_id"))), /*#__PURE__*/React.createElement(CharacterField, null, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Input, {
    type: "checkbox",
    checked: selectedCharacterConfiguration.isEnemy,
    onChange: e => selectedCharacterConfiguration.setIsEnemy(!selectedCharacterConfiguration.isEnemy)
  }), "\xA0", t("editor.character_config_is_enemy"))), selectedCharacterConfiguration.isEnemy && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CharacterField, null, t("editor.character_config_enemy_health"), /*#__PURE__*/React.createElement(InputNumber, {
    type: "number",
    min: 0,
    step: 1,
    value: selectedCharacterConfiguration.enemyHealth,
    onChange: e => onTextFieldUpdate(e, value => selectedCharacterConfiguration.setEnemyHealth(+value))
  })), /*#__PURE__*/React.createElement(CharacterField, null, t("editor.character_config_enemy_damage"), /*#__PURE__*/React.createElement(InputNumber, {
    type: "number",
    min: 0,
    step: 1,
    value: selectedCharacterConfiguration.enemyDamage,
    onChange: e => onTextFieldUpdate(e, value => selectedCharacterConfiguration.setEnemyDamage(+value))
  })), /*#__PURE__*/React.createElement(CharacterField, null, t("editor.character_config_enemy_combat_preset"), /*#__PURE__*/React.createElement(EnemyCombatPresetSelector, {
    currentModelId: selectedCharacterConfiguration.enemyCombatPresetModelId,
    setModelId: value => selectedCharacterConfiguration.setEnemyCombatPresetModelId(value)
  }))));
});